import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { } from 'googlemaps';
@Component({
  selector: 'app-mapview',
  templateUrl: './mapview.component.html',
  styleUrls: ['./mapview.component.scss']
})
export class MapviewComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map
  constructor() { }

  ngOnInit() {
    const mapProp = {
      center: new google.maps.LatLng(54.5260, 15.2551),
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP   
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
  }
  }


